import { defineMessages } from 'react-intl'

/** Shared i18n message descriptors for brand config strings */

export const leConfigMessages = defineMessages({
  searchBarText: {
    id: 'BijKy3abfC0B5VLOxR0o',
    defaultMessage: 'Search great offers for',
  },
  searchFormTitle: {
    id: '_lc0nBKTiDOmhUb7jaGo',
    defaultMessage: 'The world’s best escapes, handpicked by experts',
  },
  headMetaTitle: {
    id: 'asMhqxxhS1snrlyF5GAH',
    defaultMessage: 'Handpicked Escapes at the Best Prices on Earth',
  },
  headDefaultTitle: {
    id: 'xWRGa0e7cJW5bhPXqrxE',
    defaultMessage: 'Luxury Escapes - Handpicked Escapes at the Best Prices on Earth',
  },
  headDefaultDescription: {
    id: '-Frv3aJqbZTK0zbS1xOL',
    defaultMessage: 'Find the latest luxury travel ideas & exclusive special offers at insider prices. Save on holiday travel & accommodation packages with Luxury Escapes.',
  },
})

export const whiteLabelConfigMessages = defineMessages({
  searchBarText: {
    id: '1cp4crcANJeAHx--69rl',
    defaultMessage: 'Search',
  },
  searchFormTitle: {
    id: 'yq1_Bk95h9WsCimdG7Ad',
    defaultMessage: 'The best value holidays are right here',
  },
  headMetaTitle: {
    id: 'OGVT4jPEMpBsswgxgwAb',
    defaultMessage: 'Travel Deals & Holiday Package Deals',
  },
  headDefaultDescription: {
    id: '3BCIgk0ZXhvmFMPfqgky',
    defaultMessage: 'Travel is the one thing you buy that makes you richer. Check out travel deals & holiday package deals for your next adventure. Grab a bargain today!',
  },
})

export const cudoConfigMessages = defineMessages({
  headDefaultTitle: {
    id: 'bvblEpmNKbhdVc4WuVR8',
    defaultMessage: 'Travel Deals & Holiday Package Deals | Cudo',
  },
})

export const dealsConfigMessages = defineMessages({
  headDefaultTitle: {
    id: '3AA-HrExm3xN1-s7LEt6',
    defaultMessage: 'Travel Deals & Holiday Package Deals | Deals',
  },
})

export const scooponConfigMessages = defineMessages({
  headDefaultTitle: {
    id: 'pF-NgSGTTr8HI4njn-dX',
    defaultMessage: 'Travel Deals & Holiday Package Deals | Scoopon',
  },
})

export const treatmeConfigMessages = defineMessages({
  headDefaultTitle: {
    id: 'u_qUwIgDe-y2LDZCqiwY',
    defaultMessage: 'Travel Deals & Holiday Package Deals | TreatMe',
  },
})

export const leAgentHubConfigMessages = defineMessages({
  headMetaTitle: {
    id: 'cyzWYLZspkV81g6ETNmm',
    defaultMessage: 'LE Agent Hub - Earn commission on the world’s best travel deals',
  },
  headDefaultTitle: {
    id: 'CLhCOcIefrSa-ztldq--',
    defaultMessage: 'LE Agent Hub - Earn commission on the world’s best travel deals',
  },
  headDefaultDescription: {
    id: 'A3Ak_N0fcK85wLi9jUnw',
    defaultMessage: 'The only way to get access to Luxury Escapes Exclusive travel offers - give your clients access to the very best offers globally',
  },
})

export const cvfrConfigMessages = defineMessages({
  headMetaTitle: {
    id: 'dcaMNUSPEcjEoFlIoAe3',
    defaultMessage: 'CVFR Holidays - Earn commission on the world\'s best travel deals',
  },
  headDefaultTitle: {
    id: 'YbPSjcOV-UKD9PFwZdvn',
    defaultMessage: 'CVFR Holidays - Earn commission on the world\'s best travel deals',
  },
})

/** Shared message descriptors for "How it works" / "Why book with us" cards */
export const howItWorksMessages = defineMessages({
  // Tour offer type (shared: base, white-label, LE Agent Hub, CVFR)
  tourBestPriceGuaranteeTitle: {
    id: 'tMZS7wYi8tuAuf0H906P',
    defaultMessage: 'Best Price Guarantee',
  },
  tourBestPriceGuaranteeContent: {
    id: 'wp4slVksKGlOLelvh-Dm',
    defaultMessage: 'Found a better price? We’ll match it… plus more.',
  },
  tourHandpickedPartnersTitle: {
    id: 'OsFBVCv490zIC-OH8qDA',
    defaultMessage: 'Handpicked Partners',
  },
  tourHandpickedPartnersContent: {
    id: 'Hh2H6TJB9T703g_k-Jmh',
    defaultMessage: 'We work with the world’s most loved brands in travel',
  },
  tourCuratedByExpertsTitle: {
    id: 'qml8R0DtWXMszCqBdI6v',
    defaultMessage: 'Curated By Tour Experts',
  },
  tourCuratedByExpertsContent: {
    id: 'O2BJTU7LfwFnPiC7pmC0',
    defaultMessage: 'Saving you time researching and planning',
  },
  // Hotel offer type (base config / LE family)
  hotelWePriceMatchTitle: {
    id: '7ZkPgwvqLEhkFSqUKpny',
    defaultMessage: 'We price match',
  },
  hotelWePriceMatchContent: {
    id: 'nJ9MF-2wUJw58DF9dUBC',
    defaultMessage: 'If you find a better price, we’ll match it',
  },
  hotelChangeOfMindRefundTitle: {
    id: 'wVWnf1lIwYLO7A64ecdt',
    defaultMessage: '7-day ‘change of mind’ refund',
  },
  hotelChangeOfMindRefundContent: {
    id: 'MafTtf7AK9FqKVtflbvt',
    defaultMessage: 'Get a full refund on your booking (excludes flights, experiences and the service fee paid on deposit bookings)',
  },
  hotelVipInclusionsTitle: {
    id: '3Psru2jLEOiiMk7oyGge',
    defaultMessage: 'VIP Inclusions',
  },
  hotelVipInclusionsContent: {
    id: 'yOc5GxNI0Usu0y5eGulI',
    defaultMessage: 'You get a lot more than just a bed in a room',
  },
  hotelBuyNowTitle: {
    id: 'aq7z2mOeRQZVXK4CB5hH',
    defaultMessage: 'Buy now, choose dates later',
  },
  hotelBuyNowContent: {
    id: 'bMCGXeF2ayTGhRxwQIp_',
    defaultMessage: 'Lock in a deal today, choose dates when you’re ready',
  },
  // White-label hotel (Cudo, Deals, Scoopon, TreatMe)
  wlHotelBestPricesTitle: {
    id: 'MXmyre6vHaqxV21LTSqJ',
    defaultMessage: 'Best prices',
  },
  wlHotelBestPricesContent: {
    id: 'N93LwdlDptE1XNp87UbK',
    defaultMessage: 'We go direct to ensure you get the best price possible',
  },
  wlHotelPurchaseWithConfidenceTitle: {
    id: 'kBqbnMesrkn84rnGbqKQ',
    defaultMessage: 'Purchase with confidence',
  },
  wlHotelPurchaseWithConfidenceContent: {
    id: 'UH2AWPIiD_AnaVs88M3J',
    defaultMessage: "We offer a 7-day 'Change of Mind' no questions asked guarantee",
  },
  wlHotelQualityGuaranteedTitle: {
    id: 'warvFTakbcr-lY7UxY_o',
    defaultMessage: 'Quality guaranteed',
  },
  wlHotelQualityGuaranteedContent: {
    id: 'DGbo_RhdCbrXAQmo1PMm',
    defaultMessage: 'We test the beds to assure you have an amazing holiday',
  },
  // LE Agent Hub hotel (different title casing from base)
  agentHubHotelBestPriceTitle: {
    id: 'G0MI2FGG-R48BZg0z_PU',
    defaultMessage: 'Best price guarantee',
  },
})

/** Shared message descriptors for static page titles used across brand configs */
export const staticPageMessages = defineMessages({
  support: {
    id: 'QlnsuX0UR_VyENdutI9k',
    defaultMessage: 'Support',
  },
  termsAndConditions: {
    id: 'Alx0VXYdSUr0dhFp1x_Z',
    defaultMessage: 'Terms & Conditions',
  },
  bookingPolicies: {
    id: 'HF4w2FHSauPwGa87KZ59',
    defaultMessage: 'Booking & Refund Policies',
  },
  privacyPolicy: {
    id: 'ld8v_7j8N5oAi7vDU2vi',
    defaultMessage: 'Privacy Policy',
  },
  frequentFlyerPrograms: {
    id: 'dsgxKVBDwEdJuRNTjwRs',
    defaultMessage: 'Frequent Flyer Programs',
  },
  bestPriceGuarantee: {
    id: 'FDRnbP7tTOmgAHYAiB5g',
    defaultMessage: 'Best Price Guarantee',
  },
  luxuryEscapesGiftCards: {
    id: 'sA_tbdvsdIJnykONtloK',
    defaultMessage: 'Luxury Escapes Gift Cards',
  },
  specialProductsPromotions: {
    id: 'RF2yPw4wJ1ybCmliIS-F',
    defaultMessage: 'Special Products & Promotions',
  },
  refundPolicy: {
    id: 'Sl-atapKv0hsLXuNWk_w',
    defaultMessage: 'Refund Policy',
  },
  aboutUs: {
    id: '851XClwSGcPZqXik-Mc3',
    defaultMessage: 'About Us',
  },
  careersAndCulture: {
    id: 'Y7w_W3EP6Kk9cPjE9ybB',
    defaultMessage: 'Careers & Culture',
  },
  travelProtection: {
    id: 'pBnL-HFCSiAe00dJZrGP',
    defaultMessage: 'Travel Protection',
  },
  travelProtectionXcover: {
    id: 'kO8Eccckl3BtokLbJptG',
    defaultMessage: 'Travel Protection - xcover',
  },
  contactUs: {
    id: 'ljuoa9dIKu9Cc38NzJ9l',
    defaultMessage: 'Contact Us',
  },
  buyNowChooseDatesLater: {
    id: 'K268pMOxgLxnHWdH4ivS',
    defaultMessage: 'Buy now, choose dates later',
  },
  tourWithConfidence: {
    id: 'J2LLNsg3yjFqRNnv-rLn',
    defaultMessage: 'Tour with confidence',
  },
  escapeWithConfidence: {
    id: 'akTB8MjOdv2y1f6JPIPb',
    defaultMessage: 'Escape with confidence',
  },
  becomeAnAffiliatePartner: {
    id: 'jy0xDnt0C3rmYnqNkIsQ',
    defaultMessage: 'Become an Affiliate Partner',
  },
  luxPlusTermsAndConditions: {
    id: 'HwsT0FhjvVmcUaChzC4M',
    defaultMessage: 'LuxPlus+ Terms & Conditions',
  },
  societeTermsAndConditions: {
    id: '72HpGahLr3XdZBxGucx3',
    defaultMessage: 'Société Terms & Conditions',
  },
  societeFAQs: {
    id: 'hnENeg-43F4m735ZOwpq',
    defaultMessage: 'Société FAQs',
  },
  shopFAQs: {
    id: 'bqJEd44pu2_rNEc1Ur0L',
    defaultMessage: 'Shop FAQs',
  },
  shopTermsAndConditions: {
    id: 'ZttV2VMEr6-gTV9Miy33',
    defaultMessage: 'Shop Terms And Conditions',
  },
  directMaldivesFlights: {
    id: 'IxQa3pA55Hu_EXYVTIsI',
    defaultMessage: 'Direct Maldives Flights',
  },
})

/** Shared message descriptors for loyalty unit labels */
export const loyaltyUnitMessages = defineMessages({
  pointsCount: {
    id: 'OQGYhhYKaTqrHhqTQwr2',
    defaultMessage: '{count, plural, one {# point} other {# points}}',
  },
  pointsAbbreviationCount: {
    id: 'QQcbOIoggWUWxyuLffKC',
    defaultMessage: '{count, plural, one {# pt} other {# pts}}',
  },
  bonusPointsCount: {
    id: 'Nq-QzAJFEA9GXvMgk2s_',
    defaultMessage: '{count, plural, one {# bonus point} other {# bonus points}}',
  },
  bonusPointsAbbreviationCount: {
    id: 'LpwdDXrvm5WNx7O3eOgr',
    defaultMessage: '{count, plural, one {# bonus pt} other {# bonus pts}}',
  },
  statusCreditsCount: {
    id: 'a5W01EYIIMZ5EdYUewxP',
    defaultMessage: '{count, plural, one {# status credit} other {# status credits}}',
  },
  pointsAbbreviationPlural: {
    id: 'eamURWA8Wv13yL5yCM0m',
    defaultMessage: 'pts',
  },
})
